var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 -4 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wappen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg_rot",
    fill: "#FF0000",
    d: "M71.64,10.616c0,0-11.82-5.177-31.607-5.177h-0.006c-19.789,0-31.611,5.177-31.611,5.177 s-1.059,22.921,3.43,35.881c7.925,22.786,28.178,29.188,28.178,29.188h0.006h0.006c0,0,20.251-6.401,28.178-29.188 C72.7,33.537,71.64,10.616,71.64,10.616"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Kreuz",
    fill: "#FFFFFF",
    points: "61.035,30.375 61.035,43.002 46.302,43.002 46.302,57.736 33.674,57.736  33.674,43.002 18.94,43.002 18.94,30.375 33.674,30.375 33.674,15.645 46.298,15.645 46.302,30.375 61.035,30.375  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiss);
export default __webpack_public_path__ + "static/media/swiss.89a569075f6e565074534208ca11de8b.svg";
export { ForwardRef as ReactComponent };